export function detectMob() {
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /BlackBerry/i, /Windows Phone/i, /Linux/i];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}
